module.exports = __webpack_public_path__ + "img/3.505b19a8.png";